import AvatarStartFlow from "@/components/shared/AvatarStartFlow";

// Onboarding step 2 collapsed to the same 1-tap flow (FR29 / Story 4.4): create a
// draft and go straight into the voice builder, resuming an existing draft if any.
export default function OnboardingAvatar() {
  return (
    <AvatarStartFlow
      testid="onboarding-avatar-page"
      eyebrow="Etapa 2 de 2"
      title="Quem é a sua cliente ideal?"
      subtitle="A ValiosIA conduz uma entrevista de 7 blocos por voz — identidade, dores, desejos, objeções e a linguagem REAL da sua cliente."
    />
  );
}
